import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from '@mui/material';
import { FieldTemplate } from 'api/models';

import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { evaluateConditionGroup } from 'routes/Form/conditionUtils';

import { dialogState, selectedPatientState } from 'state';

export function FormValidationErrorsDialog() {
  const [globalDialog, setDialogState] = useRecoilState(dialogState);
  const { t } = useTranslation();
  const patient = useRecoilValue(selectedPatientState);

  const { errors, fieldTemplates, values } = globalDialog.data ?? {};
  const errorMessages = Object.entries(errors ?? {})
    .map(([key, value]) => {
      const fieldTemplate = fieldTemplates.find(
        (fieldTemplate: FieldTemplate) => fieldTemplate.id === key,
      );

      const isFieldVisible = evaluateConditionGroup({
        rootGroup: fieldTemplate?.isVisible,
        values,
        fieldTemplates,
        patient,
      });

      if (!isFieldVisible) {
        return null;
      }

      return {
        message: `${fieldTemplate?.fieldAttributes.label}: ${value}`,
        id: key,
      };
    })
    .filter(Boolean);

  return (
    <>
      <DialogTitle>{t('dialogs.formValidationErrorsDialog.title')}</DialogTitle>
      <DialogContent>
        <ul>
          {errorMessages.slice(0, 5).map(error => (
            <li key={`form-validation-error-${error!.id}`}>{error!.message}</li>
          ))}
        </ul>
        {errorMessages.length > 5 && (
          <p>
            {t('dialogs.formValidationErrorsDialog.moreErrors', {
              count: errorMessages.length - 5,
            })}
          </p>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={() => setDialogState({ ...globalDialog, isOpen: false })}
          sx={{ mr: 2, mb: 1 }}
        >
          {t('dialogs.formValidationErrorsDialog.submitButtonTitle')}
        </Button>
      </DialogActions>
    </>
  );
}
